$mol_code $mol_view
	sub /
		<= Manual $mol_search
			query? <=> value? \
			hint <= hint <= format \
		<= Scan $mol_button
			event_click? <=> event_scan? null
			sub /
				<= scan_label @ \Scan
